module.exports = __webpack_public_path__ + "fonts/TTNormsPro-ExtraBoldItalic.76ff238b.woff2";